import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetContentDescription,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { byDesign } from '@/infra/design'
import imgCreateFlowsUrl from '@/assets/misc/img_create-flows.svg'
import TeamRolesIllustration from '@/components/SpotIllustration/TeamRolesIllustration'

export interface OCRConfirmReviewDialogProps {
  showing: boolean
  onClose: () => unknown
  onConfirm: () => unknown
}

export function OCRConfirmReviewDialog({
  showing,
  onClose,
  onConfirm,
}: OCRConfirmReviewDialogProps) {
  return (
    <ModalSheet showing={showing} onRequestClose={onClose}>
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={imgCreateFlowsUrl}
            illustration={byDesign(undefined, TeamRolesIllustration)}
          />
          <ModalSheetContentTitle>
            Set this job status to “Ready to Submit”
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Are you sure you want to proceed? Once you change the status, the
            Firm Admin will be able to review and submit the job.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button label="Close" onPress={onClose} />
          <Button
            label="Set As Ready To Submit"
            variant="primary"
            onPress={onConfirm}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
